import React from 'react';
import Image from '../image';
import Video from '../video';

import './style.scss';

function EphodBio({ lang = 'en' }) {
  return (
    <div className="ephod-bio">
      <div className="ephod-image">
        <Image src="app_logo.png" alt="thumbnail" />
      </div>
      <p className="description">
        {lang === 'en'
          ? 'A strategy card game available on Android and iOS.'
          : 'Android, iOS에서 플레이할 수 있는 전략형 카드 게임입니다.'}
        <div className="app-download-buttons">
          <a href={`https://apps.apple.com/kr/app/the-ephod/id1633480108`}>
            <Image src="ios_download_button.png" alt="ios-download" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.zoomkoding.ephod">
            <Image src="android_download_button.png" alt="android-download" />
          </a>
        </div>
        {lang === 'en'
          ? `Collect gems, buy cards, and earn favor from nobles to become the ultimate priest!`
          : '보석을 모아 카드를 사고, 왕과 예언자의 인정을 받아 최고의 제사장이 되어보세요!'}
        <br />
        <br />
        <Video
          width="100%"
          height={300}
          videoSrcURL="https://www.youtube.com/embed/W4FYd9A9t4U"
          videoTitle="Official Music Video on YouTube"
        />
        <br />
        <br />
        <strong>
          {lang === 'en' ? `Need some development work done?` : '개발이 필요한 부분이 있으신가요?'}
        </strong>
        <br />
        Contact us <a href="mailto:ephod.team@gmail.com">ephod.team@gmail.com</a>.
      </p>
    </div>
  );
}

export default EphodBio;
